import React from "react";
import { LayoutHeader } from "../components";
import { About } from "../containers";

const AboutPage = () => (
  <LayoutHeader>
    <About />
  </LayoutHeader>
);

export default AboutPage;
